import { isAxiosError } from "axios";

interface ApiErrorBody {
  message?: string | string[];
}

export const getApiErrorMessage = (error: Error, fallback: string): string => {
  if (!isAxiosError<ApiErrorBody>(error)) return fallback;

  const message = error.response?.data?.message;

  if (Array.isArray(message)) return message.join(", ");

  return message || fallback;
};
